<template>
  <div>
    <!-- <div style="position:absolute;width:100%;height:100%;z-index:99"></div> -->
    <div :id="id" :style="{height:height,width:width}"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object
    },
    name: {
      type: String
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      this.chart.setOption({
        color: ['#33D1FE', '#33A2FE', '#2391ED', '#1D8FED'],
        series: {
          type: 'sankey',
          nodeWidth: 60,
          data: this.option.data,
          label: {
            normal: {
              position: 'insideLeft',
              formatter: params => {
                return `{name|${params.data.name.split('').join('\n')}\n}${params.data.arr.map(item => {
                  return `{title| \n${item.name}}{value|\n${(item.value * 100).toFixed(2)}%}`
                }).join('\n')}\n{kong|}`
              },
              rich: {
                name: {
                  color: '#fff',
                  fontSize: 20,
                  padding: [0, 0, 185, 15],
                  textAlign: 'center',
                  lineHeight: 25,
                  textBorderColor: '#33D1FE',
                  textBorderWidth: 2
                },
                title: {
                  color: 'rgba(255, 255, 255, .8)',
                  fontSize: 12,
                  lineHeight: 20,
                  padding: [0, 0, 0, 70]
                },
                value: {
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 20,
                  lineHeight: 20,
                  padding: [0, 0, 0, 70]
                },
                kong: {
                  height: 65
                }
              }
            }
          },
          links: this.option.links,
          itemStyle: {
            borderWidth: 0
          },
          lineStyle: {
            color: '#33D1FE',
            curveness: 0.5
          }
        }
      })
    }
  },
  created () {}
}
</script>
